import ENDPOINTS from 'tradera-constants/endpoints';
import axios from 'axios';
import { defaultClient as httpClient } from 'tradera-utils/http';
import { axiosConfigs } from 'tradera-utils/api';

const getCampaignCode = async (
    campaignCode,
    categoryId,
    brandAttributeValues
) => {
    var requestData = {
        code: campaignCode,
        selectedCategories: categoryId ? [categoryId] : [],
        selectedBrandAttributes: brandAttributeValues
    };
    try {
        const response = await httpClient.post(
            ENDPOINTS.SELLING_CAMPAING_CODE,
            requestData,
            {
                cancelTokenId: 'SELLING_CAMPAIGN_CODE',
                ...axiosConfigs.authenticated
            }
        );
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) {
            throw 'aborted';
        }
        throw 'Could not get the campaignCode';
    }
};

const validate = async (campaignCode, categoryId, brandAttributeValues) => {
    try {
        const data = await getCampaignCode(
            campaignCode,
            categoryId,
            brandAttributeValues
        );

        let result = {};
        result.campaignCodeValid = data.validation.isValid;
        result.validationDisplayMessage = data.validation.message;
        result.hasEnded = data.validation.hasEnded;
        if (data.campaign) {
            result.campaignCode = data.campaign.code;
            result.campaignCodeId = data.campaign.id;
            result.campaignCodeMessage = data.campaign.description;
            result.isCustomLengthFeeFree = data.campaign.isCustomLengthFeeFree;
            result.isUnsoldFeeFree = data.campaign.isUnsoldFeeFree;
            result.provisionFactor = data.campaign.provisionFactor;
            result.discountFactor = data.campaign.discountFactor;
            result.maxFeeCap = data.campaign.maxFeeCap;
            result.bannerMobileImageUrl = data.campaign.bannerMobileImageUrl;
            result.bannerTabletImageUrl = data.campaign.bannerTabletImageUrl;
            result.bannerDesktopImageUrl = data.campaign.bannerDesktopImageUrl;
        }
        return result;
    } catch (reason) {
        if (reason === 'aborted') {
            return {
                campaignCodeValid: false,
                validationDisplayMessage: 'Valideringen avbröts.'
            };
        }

        return {
            campaignCodeValid: false,
            validationDisplayMessage: 'Kunde inte validera kampanjkoden.'
        };
    }
};

export default { validate };
